module.exports = __webpack_public_path__ + "static/media/seas1.582bc506.svg";